import Header from "../../commonComponents/header/Header";
import arrowImg from "../../../assets/images/arrow-white-icon.svg";
import desktopLeftImg from "../../../assets/images/desktop-left-img.svg";
import windowsOsImg from "../../../assets/images/windows-os-img.svg";
import macOsImg from "../../../assets/images/mac-os.svg";
import { useNavigate } from "react-router-dom";

const NeedleEyeDesktopSetup = () => {
  const navigate = useNavigate();

  const handleProceed = () => {
    navigate("/needleeye-desktop-authenticate");
  };

  const downloadLinks = {
    dev_: {
      windows:
        "https://drive.google.com/file/d/1TIcRkwA72whAzRrOyTYYAYpCueOxM26e/view?usp=sharing",
      mac: "https://drive.google.com/file/d/1GU01BXVbCENOsG-VgUEo_NEnvLxFihVj/view?usp=sharing",
    },

    prod_: {
      windows:
        "https://drive.google.com/file/d/18H0dcQ1BPxJrVhuvrtuRu46n1xrolz6q/view?usp=sharing",
      mac: "https://drive.google.com/file/d/1Kn-H0sIy9zRniIfF-h7kOh6dusYTud_1/view?usp=sharing",
    },
  };

  const currentLinks = downloadLinks[process.env.REACT_APP_ENV];

  const handleWindowsDownload = () => {
    window.open(currentLinks.windows, "_blank");
  };

  const handleMacDownload = () => {
    window.open(currentLinks.mac, "_blank");
  };

  return (
    <div className="flex flex-col min-h-screen bg-white overflow-x-hidden px-4 pt-4">
      <Header />

      {/* Main */}
      <div className="flex-1 flex flex-col md:flex-row items-center justify-center px-1 pt-5 max-w-9xl mx-auto">
        {/* Left Image */}
        <div className="w-full md:w-1/2 flex justify-center items-center px-4 md:px-6 lg:px-8">
          <img
            src={desktopLeftImg}
            alt="NeedleEye Desktop Setup"
            className="object-contain w-full max-w-[520px] h-auto rounded-3xl"
          />
        </div>

        {/* Divider */}
        <div className="hidden md:block self-stretch w-[1px] bg-dividerColor mx-4 my-[5%]" />

        {/* Right Text */}
        <div className="w-full md:w-1/2 flex flex-col justify-center px-4 sm:px-6 md:px-8 lg:px-10 mt-6 md:mt-0">
          <div className="max-w-[720px]">
            <h2 className="font-semibold mb-6 leading-snug outer-font-color app-title">
              Get the NeedleEye Desktop Running
            </h2>

            <p className="mb-4 leading-relaxed outer-font-color app-body">
              If you have the NeedleEye Desktop already installed on your
              device, open it and click on{" "}
              <span className="font-semibold">"Proceed"</span>.
            </p>

            <p className="mb-4 outer-font-color app-body">
              If you haven't installed the NeedleEye Desktop yet, choose your
              Operating system from below to download and install on your
              computer.
            </p>

            <p className="mb-6 outer-font-color app-body">
              Once downloaded and installed, click on{" "}
              <span className="font-semibold">"Proceed"</span> once done.
            </p>

            {/* OS Buttons */}
            <div className="flex justify-center items-center gap-12 mt-8">
              {/* Windows */}
              <button
                onClick={handleWindowsDownload}
                className="flex items-center justify-center p-4"
              >
                <img
                  src={windowsOsImg}
                  alt="Windows"
                  className="w-auto h-100 object-contain"
                />
              </button>

              {/* macOS */}
              <button
                onClick={handleMacDownload}
                className="flex items-center justify-center p-4"
              >
                <img
                  src={macOsImg}
                  alt="macOS"
                  className="w-auto h-100 object-contain"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Button */}
      <div className="mt-auto w-full flex justify-end pb-4 pr-4">
        <button
          onClick={handleProceed}
          className="btn-size flex bg-btnBgColor items-center px-6 py-1.5 text-white text-[16px]"
        >
          Proceed
          <img src={arrowImg} alt="arrow" className="ml-2" />
        </button>
      </div>

      {/* Footer */}
      <div className="w-full py-4 text-[10px] text-gray-600 text-center px-4">
        ©{" "}
        {new Date().getFullYear() > 2026
          ? `2026-${new Date().getFullYear()}`
          : "2026"}
        , Needles and Haystacks Technology Pvt Ltd.
      </div>
    </div>
  );
};

export default NeedleEyeDesktopSetup;
